import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const sid = new URLSearchParams((window.location.hash || "").replace(/^#/, "")).get("session_id");
      if (!sid) { navigate("/admin/login", { replace: true }); return; }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        await api.post("/auth/session", {}, { headers: { "X-Session-ID": sid } });
        await refresh();
        navigate("/admin", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Inloggen met Google is mislukt.");
        setTimeout(() => navigate("/admin/login", { replace: true }), 2600);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-cc-bg flex items-center justify-center px-5">
      <div className="text-center" data-testid="auth-callback">
        {error ? (
          <p className="font-body text-cc-hot">{error}</p>
        ) : (
          <div className="flex flex-col items-center gap-3 text-cc-sub">
            <Loader2 className="w-7 h-7 animate-spin text-cc-accent" />
            <p className="font-body text-sm">Bezig met inloggen…</p>
          </div>
        )}
      </div>
    </div>
  );
}
